export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              About The Resource
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
              What Is the Vigorbuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              The Vigorbuy Spreadsheet is a structured product resource system designed to help 
              shoppers discover categorized products, compare options, understand quality 
              information through QC photos, and make smarter purchasing decisions — all from 
              one organized hub. Instead of spending hours manually browsing endless product 
              pages, the spreadsheet consolidates verified finds across multiple categories 
              into a single, easy-to-navigate database.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Whether you are a first-time international shopper or an experienced buyer looking 
              for the latest product discoveries, the Vigorbuy Spreadsheet provides a streamlined 
              shopping experience with community-verified links, detailed product comparisons, 
              and up-to-date pricing references updated weekly.
            </p>

            <div className="overflow-hidden rounded-xl border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-200/50">
                    <th className="text-left px-4 py-3 font-semibold text-foreground-800">Feature</th>
                    <th className="text-left px-4 py-3 font-semibold text-primary-600">Vigorbuy Spreadsheet</th>
                    <th className="text-left px-4 py-3 font-semibold text-foreground-700">Normal Search</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t border-background-200/70">
                    <td className="px-4 py-3 text-foreground-700">Product Discovery</td>
                    <td className="px-4 py-3 text-accent-700 font-medium">Organized database</td>
                    <td className="px-4 py-3 text-foreground-500">Manual searching</td>
                  </tr>
                  <tr className="border-t border-background-200/70">
                    <td className="px-4 py-3 text-foreground-700">Category Filter</td>
                    <td className="px-4 py-3 text-accent-700 font-medium">Available</td>
                    <td className="px-4 py-3 text-foreground-500">Limited</td>
                  </tr>
                  <tr className="border-t border-background-200/70">
                    <td className="px-4 py-3 text-foreground-700">Product Comparison</td>
                    <td className="px-4 py-3 text-accent-700 font-medium">Easy</td>
                    <td className="px-4 py-3 text-foreground-500">Difficult</td>
                  </tr>
                  <tr className="border-t border-background-200/70">
                    <td className="px-4 py-3 text-foreground-700">Buying Efficiency</td>
                    <td className="px-4 py-3 text-accent-700 font-medium">High</td>
                    <td className="px-4 py-3 text-foreground-500">Low</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20colorful%20organized%20spreadsheet%20data%20with%20product%20thumbnails%20and%20categories%2C%20surrounded%20by%20stylish%20fashion%20accessories%20leather%20wallet%20watch%20and%20sunglasses%20on%20warm%20wooden%20desk%2C%20soft%20natural%20window%20light%2C%20modern%20minimalist%20interior%2C%20cream%20walls%2C%20small%20succulent%20plant%2C%20editorial%20photography%2C%20warm%20inviting%20tones%2C%20clean%20focused%20composition%2C%20product%20research%20scene&width=800&height=600&seq=whatis-vigorbuy-new-15&orientation=landscape"
                alt="Vigorbuy Spreadsheet organized product database interface on modern laptop"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { count: '14+', label: 'Product Categories' },
            { count: '1000+', label: 'Verified Products' },
            { count: 'Weekly', label: 'Database Updates' },
            { count: '10K+', label: 'Community Members' },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">{stat.count}</div>
              <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}